import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MeetList } from '@athleticnet/athletic-live-api-models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLinkActive, RouterLink } from '@angular/router';

import { IsSidebarOpenService } from '../../shared/services/is-sidebar-open.service';

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss'],
  standalone: true,
  imports: [RouterLinkActive, RouterLink, FontAwesomeModule],
})
export class FooterMenuComponent {
  @Input() meet!: MeetList;

  constructor(public isSidebarOpenService: IsSidebarOpenService) {}

  protected readonly environment = environment;
}
